.c-button {
  --background: #1d4ed8;
  --background-hover: #2563eb;
  --background-hover-inverted: #eff6ff;
  --background-active: #1d4ed8;
  --background-active-inverted: #dbeafe;
  --text-color: white;
  --text-color-inverted: #1d4ed8;
  --border-color-inverted: #60a5fa;
  --disabled-opacity: 0.5;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  column-gap: 0.25rem;
  border-radius: 0.5rem;
  border-width: 0px;
  --tw-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.2);
  --tw-shadow-colored: inset 0 0 0 1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 600;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  white-space: nowrap;
  text-align: center;
  text-decoration-line: none;
  padding-left: 0.75rem;
  padding-right: 0.75rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;

  color: var(--text-color);
  background: var(--background);
}

  .c-button.c-button--icon-only .icon3000 {
  font-size: 1rem;
  line-height: 1.5rem;
    padding: 2px 0px;
}

  .c-button:hover, .c-button.hover {
    color: var(--text-color);
  }

  /* enabled */

  .c-button:hover:not(:disabled):not(.disabled), .c-button.hover:not(:disabled):not(.disabled) {
      background: var(--background-hover);
      cursor: pointer;
    }

  .c-button:active, .c-button.active {
    color: var(--text-color);
  }

  .c-button:active:not(:disabled):not(.disabled), .c-button.active:not(:disabled):not(.disabled) {
      background: var(--background-active);
      box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.15),
                  inset 0 1px 3px rgba(0, 0, 0, 0.2);
    }

  .c-button:focus, .c-button.focus {
    color: var(--text-color);
    outline: none;
    --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
    --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(3px + var(--tw-ring-offset-width)) var(--tw-ring-color);
    box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
    --tw-ring-opacity: 1;
    --tw-ring-color: rgb(191 219 254 / var(--tw-ring-opacity, 1));

    z-index: 1;
  }

  .c-button:disabled, .c-button.disabled {
    color: var(--text-color);
    opacity: var(--disabled-opacity);
    cursor: not-allowed;
  }

  .c-button .icon {
    margin-right: 0.25em;
  }

  .c-button--xs {
  font-size: 0.75rem;
  line-height: 1rem;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}

  .c-button--xs.c-button--icon-only .icon3000 {
  font-size: 0.875rem;
  line-height: 1.25rem;
      padding: 1px 0px;
}

  .c-button--sm {
  padding-left: 0.625rem;
  padding-right: 0.625rem;
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}

  .c-button--sm.c-button--icon-only .icon3000 {
  font-size: 1rem;
  line-height: 1.5rem;
      padding: 2px 0px;
}

  .c-button--lg {
  padding-left: 0.875rem;
  padding-right: 0.875rem;
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
  font-size: 1rem;
  line-height: 1.5rem;
}

  .c-button--lg.c-button--icon-only .icon3000 {
  font-size: 1.125rem;
  line-height: 1.75rem;
      padding: 3px 0px;
}

  .c-button--secondary {
    --background: #f4f4f5;
    --background-hover: #e4e4e7;
    --background-hover-inverted: #f4f4f5;
    --background-active: #e4e4e7;
    --background-active-inverted: #f4f4f5;
    --text-color: #52525b;
    --text-color-inverted: #3f3f46;
    --border-color-inverted: #d4d4d8;
    --disabled-opacity: 0.6;
  }

  .c-button--positive {
    --background: #16a34a;
    --background-hover:  #15803d;
    --background-hover-inverted: #f0fdf4;
    --background-active: #15803d;
    --background-active-inverted: #dcfce7;
    --text-color: white;
    --text-color-inverted: #15803d;
    --border-color-inverted: #22c55e;
    --disabled-opacity: 0.5;
  }

  .c-button--negative {
    --background: #dc2626;
    --background-hover: #ef4444;
    --background-hover-inverted: #fef2f2;
    --background-active: #ef4444;
    --background-active-inverted: #fee2e2;
    --text-color: white;
    --text-color-inverted: #dc2626;
    --border-color-inverted: #ef4444;
    --disabled-opacity: 0.5;
  }

  .c-button--inverted {
    --background: transparent;
    --background-hover: var(--background-hover-inverted);
    --background-active: var(--background-active-inverted);
    --text-color: var(--text-color-inverted);
    --disabled-opacity: 0.6;

    box-shadow: inset 0 0 0 1px var(--border-color-inverted);
  }

  .c-button--plain {
    --background: transparent;
    --background-hover: transparent;
    --background-active: transparent;
    --text-color: #52525b;
    --disabled-opacity: 0.6;

    box-shadow: none;
    padding-left: 0;
    padding-right: 0;
  }

  .c-button--plain:hover:not(:disabled):not(.disabled), .c-button--plain.hover:not(:disabled):not(.disabled) {
  --tw-text-opacity: 1;
  color: rgb(82 82 91 / var(--tw-text-opacity, 1));
}

  .c-button--plain:focus, .c-button--plain.focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(3px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(191 219 254 / var(--tw-ring-opacity, 1));
}

  .c-button--plain:active, .c-button--plain.active {
  --tw-text-opacity: 1;
  color: rgb(82 82 91 / var(--tw-text-opacity, 1));
}

  .c-button--plain:active:not(:disabled):not(.disabled), .c-button--plain.active:not(:disabled):not(.disabled) {
  --tw-text-opacity: 1;
  color: rgb(82 82 91 / var(--tw-text-opacity, 1));
        box-shadow: none;
}

/*# sourceMappingURL=data:application/json;base64,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 */